import { FC } from 'react'
import { replace, } from 'react-router-dom'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'
import { formatInput } from '@utils/phone-number-helper'


const Component: FC<{}> = () => {
    const resource = useLoader<typeof loader>()

    return (<>
        <div className="flex flex-row items-center" style={{ gap: 'inherit' }}>
            <Icons.Phone />
            <h4>{formatInput(resource.phoneNumber)}</h4>
        </div>
        {import.meta.env.DEV && (
            <div className="flex flex-col DEV-ONLY" style={{ padding: '0.4rem 0rem', gap: 'inherit' }}>
                <small>Changing Phone number is currently under development. Clerk doesn't outright support re-verification of verified resources.</small>
                <Button className="DEV-ONLY" to="./verify?replace=''">Change Phone Number</Button>
            </div>
        )}
    </>)
}

const loader = createAuthenticatedLoader(async ({ params }, Clerk) => {
    const phoneId = params['phoneId'] || ''
    const resource = Clerk.user?.phoneNumbers.find(({ id }) => id === phoneId)

    if (!!resource) return resource
    else return replace('/account/profile')
})

const ViewPhoneRoute: RouteObject = {
    index: true,
    Component,
    loader,
}

export { ViewPhoneRoute }